import { reatomAsync } from "@reatom/async";
import { atom } from "@reatom/framework";
import { AwardSubscribeRequestDto } from "definitions/poizon-bff";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";
import {
  createInvoiceResult,
  type InvoiceResult,
} from "src/pages/AdminUserPage/widgets/UserInfo/store/atoms";
import { toastHandler } from "src/util";

export const ordersRefreshTrigger = atom(0, "ordersRefreshTrigger");

export type CreateInvoiceMode = "paid" | "free";

interface CreateInvoiceArgs {
  mode: CreateInvoiceMode;
  dto: AwardSubscribeRequestDto;
}

export const createInvoiceRequest = reatomAsync(
  async (_, { mode, dto }: CreateInvoiceArgs): Promise<InvoiceResult> => {
    if (mode === "free") {
      await API.awardAdminApi.awardAdminOrderControllerSubscribeByUserId(dto);
      return { mode: "free" };
    }
    const { data } =
      await API.paymentApi.paymentControllerPaymentSubscribeByUserId(dto);
    return {
      mode: "paid",
      link: data.link,
      totalAmount: String(data.totalAmount),
    };
  },
  {
    name: "createInvoiceRequest",
    onFulfill: (ctx, response) => {
      createInvoiceResult(ctx, response);
      ordersRefreshTrigger(ctx, (prev) => prev + 1);
    },
    onReject: (_ctx, error) => {
      const message =
        error instanceof Error ? error.message : "Попробуйте ещё раз";
      toastHandler.error({
        name: "create-invoice-failed",
        title: "Не удалось создать счёт",
        content: message,
      });
    },
  },
).pipe(withIsLoadingAtom());
